// Toute l'application est cote client : Three.js et Threlte ne fonctionnent pas en SSR.
// Le SPA fallback de adapter-static garantit que les routes dynamiques (/callback) marchent.
export const ssr = false;
export const prerender = true;
